/**
 * Typdefinitioner för EnergyConsumptionReport
 * Energiförbrukningsrapport för fordon
 */

export interface Organization {
  id: string;
  name: string;
}

export interface EnergyStats {
  vehicleId: number;
  registrationNumber: string;
  make: string;
  model: string;
  organizationName: string;
  totalTrips: number;
  totalDistance: number;
  totalFuelUsed: number;
  avgFuelConsumption: number;
  wltpConsumption: number | null;
  isElectric: boolean;
  avgSpeed: number;
  totalDrivingTime: number;
}

export interface OrganizationEnergyStats {
  organizationId: string;
  organizationName: string;
  vehicleCount: number;
  totalTrips: number;
  totalDistance: number;
  totalFuelUsed: number;
  avgFuelConsumption: number;
}

export interface EnergySummary {
  totalOrganizations: number;
  totalVehicles: number;
  totalTrips: number;
  totalDistance: number;
  totalFuelUsed: number;
  avgFuelConsumption: number;
}

export interface TrendData {
  period: string;
  totalDistance: number;
  totalFuelUsed: number;
  avgFuelConsumption: number;
  tripCount: number;
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export type EnergyTab = 'overview' | 'organizations' | 'vehicles' | 'trend';

export const CHART_COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#8884D8',
  '#82CA9D',
];

// Get default date range (last 30 days)
export function getDefaultDateRange(): DateRange {
  return {
    startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split('T')[0],
    endDate: new Date().toISOString().split('T')[0],
  };
}

// Get consumption color class
export function getConsumptionColorClass(
  consumption: number,
  wltp?: number | null
): string {
  const isOverWltp = wltp && consumption > wltp * 1.1;
  if (isOverWltp) return 'bg-red-100 text-red-800';
  if (consumption < 8) return 'bg-green-100 text-green-800';
  if (consumption < 12) return 'bg-yellow-100 text-yellow-800';
  return 'bg-red-100 text-red-800';
}
